// extracted by mini-css-extract-plugin
module.exports = {"sticky":"StickyContact_sticky__2V03t"};